import { useTranslation } from 'react-i18next'

import ReveniBackground from '../components/ReveniBackground'
import RouterLink from '../components/RouterLink'
import routes from '../Router/routes.constants'

const PageNotFound = () => {
  const { t } = useTranslation()

  return (
    <ReveniBackground>
      <h2>{t('¡Página no encontrada!')}</h2>
      <h3>{t('Lo sentimos, pero no se pudo encontrar la página que estabas buscando')}.</h3>
      <p>
        {t('Puedes volver al ')}
        <RouterLink to={routes.home}>{t('principio')}</RouterLink>,{' '}
        {t('o escribirnos a support@reveni.io si no encuentras lo que estabas buscando')}.
      </p>
    </ReveniBackground>
  )
}

export default PageNotFound
